import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../store";

export const useUserPreferences = (): void => {
  const dispatch = useDispatch();
  const { updateTimeFormat, updateLocal } = bindActionCreators(
    actionCreators,
    dispatch
  );

  useEffect(() => {
    const abortController = new AbortController();

    const use24hTimeFormat = localStorage.getItem("use24hTimeFormat");
    if (use24hTimeFormat !== null) {
      updateTimeFormat(true);
    }

    const local = localStorage.getItem("local") || "it-IT";
    updateLocal(local);

    return () => {
      abortController.abort();
    };
  }, [updateLocal, updateTimeFormat]);
};
